<template>
  <div class="cp-form-search-offer">
    <h3 class="title-select" />
    <div class="select-content">
      <p class="text-select" />
      <tequila-custom-select
        :placeholder-option="placeholder"
        name="filter-seach"
        :options="list.data.countries"
        :option-keys="['value', 'label']"
        @input="redirect"
      />
    </div>
  </div>
</template>
<script>
import tequilaCustomSelect from 'teq-custom-select';

export default {
  components: {
    tequilaCustomSelect,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      list: JSON.parse(this.data),
    };
  },

  /**
     * Remove the placeholder from the list open
    */
  mounted() {
    const property = document.querySelectorAll('.custom-select-option')
    property[0].style.display = 'none';

    this.convertStr(this.title, '.title-select')
    this.convertStr(this.text, '.text-select')
  },

  methods: {
    /**
     * Get the the link and open it in a new tab
     * @param {String} value - The link of the option
    */
    redirect({ value }) {
      window.open(value, '_blank')
    },

    /**
     * Convert a string with HTML content (ex : <br>) into a HTML element
     * and add it to a specific block
     * @param {String} value - The string to convert
     * @param {String} container - The block where the string will be add
     */
    convertStr(value, container) {
      const str = value;
      const block = document.querySelector(container)
      block.innerHTML = str;
    },
  },
}

</script>
